export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const tamanyoCamaRegex = /^[0-9]{0,3}[xX][0-9]{0,3}$/;
export const macCamaRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

export const SESSION_AUTHENTICATION_KEY = '2befd0c6-9266-4cf1-8f87-2f77b60ec144';

export const ROUTE_ROOT = '/';
export const ROUTE_ESTABLECIMIENTOS = '/establecimientos';
export const ROUTE_HABITACIONES = '/habitaciones';
export const ROUTE_EMPLEADOS = '/empleados';
export const ROUTE_CAMAS = '/camas'
export const ROUTE_PERSONAL = '/personal';
export const ROUTE_CADENAS = '/cadenas';
export const ROUTE_DESCARGA = '/descarga';
export const ROUTE_MICUENTA = '/mi-cuenta';
export const ROUTE_RESET_PASSWORD = '/restablecer-contrasena';
export const ROUTE_PASSWORD = '/password';
export const ROUTE_NOT_FOUND = '/not-found';
export const ROUTE_NOT_AUTH = '/not-auth';

export const ROLE_USUARIO_ADMINISTRADOR = 1;
export const ROLE_USUARIO_GESTOR = 2;
export const ROLE_USUARIO_TRABAJADOR = 3;
export const ROLE_USUARIO_ADMIN_CADENA = 4;
//Roles ficticios para la pagina de navegación permisos
export const ROLE_USUARIO_TRABAJADOR_GOBERNANTA = 5;
export const ROLE_USUARIO_TRABAJADOR_MANT = 6;
export const ROLE_USUARIO_TRABAJADOR_RECEPCION = 7;

export const TIPO_EMPLEADO_GERENTE = 1;
export const TIPO_EMPLEADO_RECEPCION = 2;
export const TIPO_EMPLEADO_MANTENIMIENTO = 3;
export const TIPO_EMPLEADO_CAMARERO = 4;
export const TIPO_EMPLEADO_GOBERNANTA = 5;

export const ESTADO_HABITACION_NO_OCUPADA = 1;
export const ESTADO_HABITACION_LIMPIAR = 2;
export const ESTADO_HABITACION_SALIDA = 3;